const Modal = ({ onClose, children }) => (
  <div className="fixed inset-0 mt-[150px] bg-black bg-opacity-50 flex justify-center items-center">
    <div className="bg-slate-200 p-4 rounded-lg max-w-xl mx-auto relative dark:bg-gray-400">
      <button onClick={onClose} className="absolute top-2 right-2 px-2 w-10 h=10 bg-primary text-xl rounded-full text-white cursor-pointer">X</button>
      {children}
    </div>
  </div>
);

export default Modal;